import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import PhotoThumbnail from './PhotoThumbnail';
import PhotoDeleteConfirmationModal from './PhotoDeleteConfirmationModal';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

import axios from '../../../sharedModules/utils/axios.utils';

interface PhotosSectionProps {
  isTechnicianUser: boolean;
}
// TODO: Figure out what we wanted to use isTechnicianUser for

const PhotosSection: React.FunctionComponent<PhotosSectionProps> = (props) => {
  const { id } = useParams<{ id: string }>();

  let { chillerLog, fetchChillerLogPhotos, chillerLogPhotos } = useContext(ChillerLogsContext);

  let [expanded, setExpanded] = useState(true);

  useEffect(() => {
    if (chillerLog?.id && chillerLogPhotos.length === 0) {
      fetchChillerLogPhotos();
    }
  }, [chillerLog]);

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const fileInput = event.target;
      const fileDataArray = Array.from(event.target.files);

      try {
        const uploadPromises = fileDataArray.map((attachedFile) => {
          const data = new FormData();
          data.append('file', attachedFile, attachedFile.name);
          data.append('id', id);
          return axios.post<any, any>('/chiller_logs/chiller_log_photos.json', data);
        });

        await Promise.all(uploadPromises);

        fetchChillerLogPhotos();
      } catch (error) {
        console.error('Error uploading files:', error);
      } finally {
        // Always reset the file input
        if (fileInput) {
          fileInput.value = '';
        }
      }
    }
  };

  return (
    <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
      <AccordionSummary style={{ background: '#A21C37' }}>
        <h3 style={{ background: '#A21C37', color: '#fff', fontWeight: 700, padding: 5 }}>Photos</h3>
      </AccordionSummary>
      <AccordionDetails style={{ background: '#fff', padding: 5 }} className="no-print">
        <PhotoDeleteConfirmationModal />
        {chillerLogPhotos.length === 0 && (
          <p style={{ margin: '10px 0' }}>No photos have been uploaded for this job.</p>
        )}
        {chillerLogPhotos.length > 0 && (
          <Grid container spacing={2} style={{ marginTop: 10 }}>
            {chillerLogPhotos.map((chillerLogPhoto, index) => (
              <PhotoThumbnail chillerLogPhoto={chillerLogPhoto} />
            ))}
          </Grid>
        )}

        <input type="file" id="file-upload" multiple style={{ display: 'none' }} onChange={handleFileChange} />
        <Button style={{}} variant="contained" component="label" htmlFor="file-upload">
          Upload Photos/Files
        </Button>
      </AccordionDetails>
    </Accordion>
  );
};

export default PhotosSection;
